var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 19,
    viewBox: "0 0 21 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.232 2C11.462.667 9.538.667 8.768 2L1.407 14.75c-.77 1.333.192 3 1.732 3H17.86c1.54 0 2.502-1.667 1.732-3zm-.804 4.708c0 .384-.324.72-.708.72a.72.72 0 0 1-.72-.72.72.72 0 0 1 .72-.708c.384 0 .708.336.708.708m-.714 7.956a.594.594 0 0 1-.594-.594V9.054a.594.594 0 1 1 1.188 0v5.016a.594.594 0 0 1-.594.594",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;